import { useQuery } from '@tanstack/react-query';

import { GlobalReactQueryOptions } from '../../config';
import { fetchBundleDetailTotals, FetchBundleTotalsApiResponse } from './fetchBundleDetailTotals';
import { PriceTier } from '../../../models/PriceTier';
import { UseQueryResult } from '../query-types';

export type UseFetchBundleTotalsQuery = UseQueryResult<'data', FetchBundleTotalsApiResponse | undefined>;

export const useBundleDetailTotals = (
    bundleId: string | undefined,
    priceTier: PriceTier
): UseFetchBundleTotalsQuery => {
    const params = {
        bundleId: bundleId ?? '',
        priceTier
    };

    const { data, ...result } = useQuery(['fetchBundleTotals', params], () => fetchBundleDetailTotals(params), {
        ...GlobalReactQueryOptions,
        staleTime: Infinity,
        enabled: !!bundleId
    });

    return {
        ...result,
        data
    };
};
